<div class="search-container" [ngClass]="{ 'flex-gap-20': activityFilter }">
  <app-textfield
    [disabled]="disableSearch"
    [size]="searchSize"
    placeholder="Search..."
    (valueChange)="onChange($event)"
    iconUrl="../../../../assets/images/icons/search.svg"
    data-cy="search-input"
  ></app-textfield>
  @if (activityFilter) {
    <div #typesBtnContainer class="types-container">
      <button class="type-filter" (click)="typeOptionsOpened = !typeOptionsOpened" data-cy="type-filter-btn" [disabled]="disableTypeFilter">
        <img src="../../../../assets/images/icons/filter.svg" alt="filter" class="icon-left" />
        Activity Type:
        @if (typeSelected.length === 0) {
          <strong>None</strong>
        }
        @if (typeOptions?.length && typeSelected.length === typeOptions.length) {
          <strong>All</strong>
        }
        @if (typeSelected.length > 0 && typeSelected.length !== typeOptions?.length) {
          <strong data-cy="type-label-selected">{{ typeSelected.length > 1 ? typeSelected.length + ' selected' : typeSelected[0].label }}</strong>
        }
        <img src="../../../../assets/images/icons/chevron-up.svg" alt="arrow-up" class="icon-right" />
      </button>
      @if (typeOptions && typeOptionsOpened) {
        <div class="types-dropdown" data-cy="types-dropdown">
          @for (type of typeOptions; track type.id) {
            <div class="option" (click)="$event.preventDefault(); typeFilterChange(type)" data-cy="type-options-dropdown">
              <input [id]="type.id" type="checkbox" [checked]="optionIsChecked(type.id)" />
              <label [for]="type.id" class="checkbox" data-cy="option-checkbox"></label>
              <label [for]="type.id" class="label">
                {{ type.label }}
              </label>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
<div #actionsContainer class="actions-container">
  @if (newItemButtonLabel) {
    <app-button
      type="primary"
      iconUrl="../../../../assets/images/icons/plus.svg"
      (click)="newItemOptions ? (optionsOpened = !optionsOpened) : addNew()"
      data-cy="new-content-btn"
    >
      {{ newItemButtonLabel }}
    </app-button>
  }
  @if (showCancelButton) {
    <app-button
      type="warning"
      matTooltip="Go back without saving"
      iconUrl="../../../../assets/images/icons/cancel.svg"
      (click)="onCancelCallback && onCancelCallback.emit()"
    >
      Cancel
    </app-button>
  }
  @if (newItemOptions && optionsOpened) {
    <div class="options-dropdown" data-cy="item-options-dropdown">
      @for (option of newItemOptions; track option.url) {
        <div class="option" (click)="goTo(option.url)" data-cy="options-content">
          @if (option.icon) {
            <img [src]="option.icon" />
          }
          <span>{{ option.label }}</span>
        </div>
      }
    </div>
  }
</div>
